import { Provider } from '@servicetitan/react-ioc';
import { FC, PropsWithChildren } from 'react';
import { SEARCH_STORE_TOKEN, SearchStore } from '../../shared';

export const SearchProvider: FC<PropsWithChildren> = ({ children }) => {
    return (
        <Provider
            singletons={[
                {
                    provide: SEARCH_STORE_TOKEN,
                    useClass: SearchStore,
                },
            ]}
        >
            {children}
        </Provider>
    );
};
